import { Location } from 'react-router-dom'

type LocationLike = {
  pathname?: string
  search?: string
  hash?: string
}

function pathFromLocationLike(loc: LocationLike | undefined, fallback: string) {
  if (!loc?.pathname) return fallback
  return `${loc.pathname}${loc.search || ''}${loc.hash || ''}`
}

/** Prefer `from` (full-page auth) then legacy `backgroundLocation` (modal era). */
export function getBackgroundPathFromState(
  state: unknown,
  fallback = '/'
): string {
  const from = (state as { from?: LocationLike } | null)?.from
  const fromPath = pathFromLocationLike(from, '')
  if (fromPath) return fromPath

  const backgroundLocation = (state as { backgroundLocation?: Location } | null)
    ?.backgroundLocation
  return pathFromLocationLike(backgroundLocation, fallback)
}

export function hasBackgroundLocation(state: unknown): boolean {
  const from = (state as { from?: LocationLike } | null)?.from
  if (from?.pathname) return true
  return Boolean(
    (state as { backgroundLocation?: Location } | null)?.backgroundLocation
      ?.pathname
  )
}
